import { TranslationChunksConfig } from '@spartacus/core';
import userProfileEn from './en/userProfile.json';
import userProfileEs from './es/userProfile.json';

export const customUserProfileTranslationsEn = {
  userProfile: userProfileEn
};

export const customUserProfileTranslationsEs = {
  userProfile: userProfileEs
};

export const customUserProfileTranslationsChunksConfig: TranslationChunksConfig = {
  userProfile: ['register', 'forgottenPassword']
};
